import { NgModule } from '@angular/core';
import { NewFormComponent } from './new-form/new-form.component';
import { FormBuilderRoutingModule } from './form-builder-routing.module';
import { FormsModule } from '@angular/forms';
import { AtlasSharedModule } from '../shared/module/atlas-shared.module';
import { ThirdPartySharedModule } from '../shared/module/third-party-shared.module';
import { TranslationService } from '../shared';
import { DonationFormEditComponent } from './donation-form-edit/donation-form-edit.component';
import { RenewalFormEditComponent } from './renewal-form-edit/renewal-form-edit.component';
import { ProspectFormEditComponent } from './prospect-form-edit/prospect-form-edit.component';
import { GeneralFormEditComponent } from './general-form-edit/general-form-edit.component';
import { FormSettingsComponent } from './form-settings/form-settings.component';
import { FormV2ElementEditComponent } from './form-v2-element-edit/form-v2-element-edit.component';
import { ProfileLegoEditComponent } from './lego/profile-lego-edit/profile-lego-edit.component';
import { ProfileLegoSummaryComponent } from './lego/profile-lego-summary/profile-lego-summary.component';
import { PurchaseItemLegoEditComponent } from './lego/purchase-item-lego-edit/purchase-item-lego-edit.component';
import { PurchaseItemLegoSummaryComponent } from './lego/purchase-item-lego-summary/purchase-item-lego-summary.component';
import { FormSubmissionListComponent } from './form-submission-list/form-submission-list.component';
import { FormListComponent } from './form-list/form-list.component';
import { CustomFieldLegoEditComponent } from './lego/custom-field-lego-edit/custom-field-lego-edit.component';
import { CustomFieldLegoSummaryComponent } from './lego/custom-field-lego-summary/custom-field-lego-summary.component';
import { AffiliationCodeLegoEditComponent } from './lego/affiliation-code-lego-edit/affiliation-code-lego-edit.component';
import { AffiliationCodeLegoSummaryComponent } from './lego/affiliation-code-lego-summary/affiliation-code-lego-summary.component';
import { ListingLegoEditComponent } from './lego/listing-lego-edit/listing-lego-edit.component';
import { ListingLegoSummaryComponent } from './lego/listing-lego-summary/listing-lego-summary.component';
import { MembershipLevelLegoEditComponent } from './lego/membership-level-lego-edit/membership-level-lego-edit.component';
import { MembershipLevelLegoSummaryComponent } from './lego/membership-level-lego-summary/membership-level-lego-summary.component';
import { FormSubmissionSearchParamsComponent } from './form-submission-list/form-submission-search-params/form-submission-search-params.component';
import { SocialMediaLegoEditComponent } from './lego/social-media-lego-edit/social-media-lego-edit.component';
import { SocialMediaLegoSummaryComponent } from './lego/social-media-lego-summary/social-media-lego-summary.component';
import { FormSubmissionViewModalComponent } from './form-submission-list/form-submission-view-modal/form-submission-view-modal.component';
import { FileUploadLegoEditComponent } from './lego/file-upload-lego-edit/file-upload-lego-edit.component';
import { FileUploadLegoSummaryComponent } from './lego/file-upload-lego-summary/file-upload-lego-summary.component';
import { OpenFieldLegoEditComponent } from './lego/open-field-lego-edit/open-field-lego-edit.component';
import { OpenFieldLegoSummaryComponent } from './lego/open-field-lego-summary/open-field-lego-summary.component';
import { EmailOptInLegoSummaryComponent } from './lego/email-optin-lego-summary/email-optin-lego-summary.component';
import { EmailOptInLegoEditComponent } from './lego/email-optin-lego-edit/email-optin-lego-edit.component';

@NgModule({
  declarations: [
    NewFormComponent,
    DonationFormEditComponent,
    RenewalFormEditComponent,
    GeneralFormEditComponent,
    FormSettingsComponent,
    FormV2ElementEditComponent,
    ProfileLegoEditComponent,
    ProfileLegoSummaryComponent,
    PurchaseItemLegoEditComponent,
    PurchaseItemLegoSummaryComponent,
    ProspectFormEditComponent,

    FormSubmissionListComponent,
    FormListComponent,
    CustomFieldLegoEditComponent,
    CustomFieldLegoSummaryComponent,
    AffiliationCodeLegoEditComponent,
    AffiliationCodeLegoSummaryComponent,
    ListingLegoEditComponent,
    ListingLegoSummaryComponent,
    MembershipLevelLegoEditComponent,
    MembershipLevelLegoSummaryComponent,
    FormSubmissionSearchParamsComponent,
    SocialMediaLegoEditComponent,
    SocialMediaLegoSummaryComponent,
    FormSubmissionViewModalComponent,
    FileUploadLegoEditComponent,
    FileUploadLegoSummaryComponent,
    OpenFieldLegoEditComponent,
    OpenFieldLegoSummaryComponent,
    EmailOptInLegoEditComponent,
    EmailOptInLegoSummaryComponent
  ],
  imports: [FormBuilderRoutingModule, AtlasSharedModule, FormsModule, ThirdPartySharedModule],
})
export class FormBuilderModule {}
